// Send OTP
export const SEND_OTP_REQUECT = "SEND_OTP_REQUECT";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAIL = "SEND_OTP_FAIL";
export const SEND_OTP_RESET = "SEND_OTP_RESET";

// Login
export const CUSTOMER_LOGIN_REQUEST = "CUSTOMER_LOGIN_REQUEST";
export const CUSTOMER_LOGIN_SUCCESS = "CUSTOMER_LOGIN_SUCCESS";
export const CUSTOMER_LOGIN_FAIL = "CUSTOMER_LOGIN_FAIL";
export const CUSTOMER_LOGIN_RESET = "CUSTOMER_LOGIN_RESET";

// Logout
export const CUSTOMER_LOGOUT = "CUSTOMER_LOGOUT";

// Get logged in user
export const GET_LOGGED_IN_CUSTOMER_REQUEST = "GET_LOGGED_IN_CUSTOMER_REQUEST";
export const GET_LOGGED_IN_CUSTOMER_SUCCESS = "GET_LOGGED_IN_CUSTOMER_SUCCESS";
export const GET_LOGGED_IN_CUSTOMER_FAIL = "GET_LOGGED_IN_CUSTOMER_FAIL";
export const GET_LOGGED_IN_CUSTOMER_RESET = "GET_LOGGED_IN_CUSTOMER_RESET";

// Get customer by id
export const GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL";
export const GET_CUSTOMER_RESET = "GET_CUSTOMER_RESET";

// Change Password
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";

// Create customer user
export const CREATE_CUSTOMER_USER_REQUEST = "CREATE_CUSTOMER_USER_REQUEST";
export const CREATE_CUSTOMER_USER_SUCCESS = "CREATE_CUSTOMER_USER_SUCCESS";
export const CREATE_CUSTOMER_USER_FAIL = "CREATE_CUSTOMER_USER_FAIL";
export const CREATE_CUSTOMER_USER_RESET = "CREATE_CUSTOMER_USER_RESET";

// Get all customer users (users which are created by customer)
export const GET_CUSTOMER_USERS_REQUEST = "GET_CUSTOMER_USERS_REQUEST";
export const GET_CUSTOMER_USERS_SUCCESS = "GET_CUSTOMER_USERS_SUCCESS";
export const GET_CUSTOMER_USERS_FAIL = "GET_CUSTOMER_USERS_FAIL";
export const GET_CUSTOMER_USERS_RESET = "GET_CUSTOMER_USERS_RESET";

// Get customer user by id
export const GET_CUSTOMER_USER_BY_ID_REQUEST =
  "GET_CUSTOMER_USER_BY_ID_REQUEST";
export const GET_CUSTOMER_USER_BY_ID_SUCCESS =
  "GET_CUSTOMER_USER_BY_ID_SUCCESS";
export const GET_CUSTOMER_USER_BY_ID_FAIL = "GET_CUSTOMER_USER_BY_ID_FAIL";
export const GET_CUSTOMER_USER_BY_ID_RESET = "GET_CUSTOMER_USER_BY_ID_RESET";

// Update customer user
export const UPDATE_CUSTOMER_USER_REQUEST = "UPDATE_CUSTOMER_USER_REQUEST";
export const UPDATE_CUSTOMER_USER_SUCCESS = "UPDATE_CUSTOMER_USER_SUCCESS";
export const UPDATE_CUSTOMER_USER_FAIL = "UPDATE_CUSTOMER_USER_FAIL";
export const UPDATE_CUSTOMER_USER_RESET = "UPDATE_CUSTOMER_USER_RESET";

// Delete customer user
export const DELETE_CUSTOMER_USER_REQUEST = "DELETE_CUSTOMER_USER_REQUEST";
export const DELETE_CUSTOMER_USER_SUCCESS = "DELETE_CUSTOMER_USER_SUCCESS";
export const DELETE_CUSTOMER_USER_FAIL = "DELETE_CUSTOMER_USER_FAIL";
export const DELETE_CUSTOMER_USER_RESET = "DELETE_CUSTOMER_USER_RESET";

// Get Customer User Permission
export const GET_CUSTOMER_USER_PERMISSION_REQUEST =
  "GET_CUSTOMER_USER_PERMISSION_REQUEST";
export const GET_CUSTOMER_USER_PERMISSION_SUCCESS =
  "GET_CUSTOMER_USER_PERMISSION_SUCCESS";
export const GET_CUSTOMER_USER_PERMISSION_FAIL =
  "GET_CUSTOMER_USER_PERMISSION_FAIL";
export const GET_CUSTOMER_USER_PERMISSION_RESET =
  "GET_CUSTOMER_USER_PERMISSION_RESET";

// Get logged in customer logins
export const GET_LOGGED_IN_CUSTOMER_LOGINS_REQUEST =
  "GET_LOGGED_IN_CUSTOMER_LOGINS_REQUEST";
export const GET_LOGGED_IN_CUSTOMER_LOGINS_SUCCESS =
  "GET_LOGGED_IN_CUSTOMER_LOGINS_SUCCESS";
export const GET_LOGGED_IN_CUSTOMER_LOGINS_FAIL =
  "GET_LOGGED_IN_CUSTOMER_LOGINS_FAIL";
export const GET_LOGGED_IN_CUSTOMER_LOGINS_RESET =
  "GET_LOGGED_IN_CUSTOMER_LOGINS_RESET";

// Update Customer Profile
export const UPDATE_CUSTOMER_PROFILE_REQUEST =
  "UPDATE_CUSTOMER_PROFILE_REQUEST";
export const UPDATE_CUSTOMER_PROFILE_SUCCESS =
  "UPDATE_CUSTOMER_PROFILE_SUCCESS";
export const UPDATE_CUSTOMER_PROFILE_FAIL = "UPDATE_CUSTOMER_PROFILE_FAIL";
export const UPDATE_CUSTOMER_PROFILE_RESET = "UPDATE_CUSTOMER_PROFILE_RESET";

// Get all countries
export const GET_ALL_COUNTRY_REQUEST = "GET_ALL_COUNTRY_REQUEST";
export const GET_ALL_COUNTRY_SUCCESS = "GET_ALL_COUNTRY_SUCCESS";
export const GET_ALL_COUNTRY_FAIL = "GET_ALL_COUNTRY_FAIL";
export const GET_ALL_COUNTRY_RESET = "GET_ALL_COUNTRY_RESET";

// Change password from profile
export const CHANGE_PASSWORD_FROM_PROFILE_REQUEST =
  "CHANGE_PASSWORD_FROM_PROFILE_REQUEST";
export const CHANGE_PASSWORD_FROM_PROFILE_SUCCESS =
  "CHANGE_PASSWORD_FROM_PROFILE_SUCCESS";
export const CHANGE_PASSWORD_FROM_PROFILE_FAIL =
  "CHANGE_PASSWORD_FROM_PROFILE_FAIL";
export const CHANGE_PASSWORD_FROM_PROFILE_RESET =
  "CHANGE_PASSWORD_FROM_PROFILE_RESET";

// Get Manage Booking Data
export const GET_MANAGE_BOOKING_DATA_REQUEST =
  "GET_MANAGE_BOOKING_DATA_REQUEST";
export const GET_MANAGE_BOOKING_DATA_SUCCESS =
  "GET_MANAGE_BOOKING_DATA_SUCCESS";
export const GET_MANAGE_BOOKING_DATA_FAIL = "GET_MANAGE_BOOKING_DATA_FAIL";
export const GET_MANAGE_BOOKING_DATA_RESET = "GET_MANAGE_BOOKING_DATA_RESET";

// Check logged in user pcc
export const CHECK_LOGGED_IN_USER_PCC_REQUEST =
  "CHECK_LOGGED_IN_USER_PCC_REQUEST";
export const CHECK_LOGGED_IN_USER_PCC_SUCCESS =
  "CHECK_LOGGED_IN_USER_PCC_SUCCESS";
export const CHECK_LOGGED_IN_USER_PCC_FAIL = "CHECK_LOGGED_IN_USER_PCC_FAIL";
export const CHECK_LOGGED_IN_USER_PCC_RESET = "CHECK_LOGGED_IN_USER_PCC_RESET";

// Print itinerary
export const PRINT_ITINERARY_DATA_REQUEST = "PRINT_ITINERARY_DATA_REQUEST";
export const PRINT_ITINERARY_DATA_SUCCESS = "PRINT_ITINERARY_DATA_SUCCESS";
export const PRINT_ITINERARY_DATA_FAIL = "PRINT_ITINERARY_DATA_FAIL";
export const PRINT_ITINERARY_DATA_RESET = "PRINT_ITINERARY_DATA_RESET";

// Email itinerary
export const EMAIL_ITINERARY_DATA_REQUEST = "EMAIL_ITINERARY_DATA_REQUEST";
export const EMAIL_ITINERARY_DATA_SUCCESS = "EMAIL_ITINERARY_DATA_SUCCESS";
export const EMAIL_ITINERARY_DATA_FAIL = "EMAIL_ITINERARY_DATA_FAIL";
export const EMAIL_ITINERARY_DATA_RESET = "EMAIL_ITINERARY_DATA_RESET";

// Check customer user username availability
export const CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_REQUEST =
  "CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_REQUEST";
export const CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_SUCCESS =
  "CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_SUCCESS";
export const CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_FAIL =
  "CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_FAIL";
export const CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_RESET =
  "CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_RESET";

// Get Logged in Customer user
export const GET_LOGGED_IN_CUSTOMER_USER_REQUEST =
  "GET_LOGGED_IN_CUSTOMER_USER_REQUEST";
export const GET_LOGGED_IN_CUSTOMER_USER_SUCCESS =
  "GET_LOGGED_IN_CUSTOMER_USER_SUCCESS";
export const GET_LOGGED_IN_CUSTOMER_USER_FAIL =
  "GET_LOGGED_IN_CUSTOMER_USER_FAIL";
export const GET_LOGGED_IN_CUSTOMER_USER_RESET =
  "GET_LOGGED_IN_CUSTOMER_USER_RESET";

// Update Customer User Profile
export const UPDATE_CUSTOMER_USER_PROFILE_REQUEST =
  "UPDATE_CUSTOMER_USER_PROFILE_REQUEST";
export const UPDATE_CUSTOMER_USER_PROFILE_SUCCESS =
  "UPDATE_CUSTOMER_USER_PROFILE_SUCCESS";
export const UPDATE_CUSTOMER_USER_PROFILE_FAIL =
  "UPDATE_CUSTOMER_USER_PROFILE_FAIL";
export const UPDATE_CUSTOMER_USER_PROFILE_RESET =
  "UPDATE_CUSTOMER_USER_PROFILE_RESET";

// Get Customer user logo by cust_user_id
export const GET_CUSTOMER_USER_LOGOS_REQUEST =
  "GET_CUSTOMER_USER_LOGOS_REQUEST";
export const GET_CUSTOMER_USER_LOGOS_SUCCESS =
  "GET_CUSTOMER_USER_LOGOS_SUCCESS";
export const GET_CUSTOMER_USER_LOGOS_FAIL = "GET_CUSTOMER_USER_LOGOS_FAIL";
export const GET_CUSTOMER_USER_LOGOS_RESET = "GET_CUSTOMER_USER_LOGOS_RESET";

// Delete customer user logo
export const DELETE_CUSTOMER_USER_LOGO_REQUEST =
  "DELETE_CUSTOMER_USER_LOGO_REQUEST";
export const DELETE_CUSTOMER_USER_LOGO_SUCCESS =
  "DELETE_CUSTOMER_USER_LOGO_SUCCESS";
export const DELETE_CUSTOMER_USER_LOGO_FAIL = "DELETE_CUSTOMER_USER_LOGO_FAIL";
export const DELETE_CUSTOMER_USER_LOGO_RESET =
  "DELETE_CUSTOMER_USER_LOGO_RESET";

// Grt Ticket Report
export const GET_TICKET_REPORT_REQUEST = "GET_TICKET_REPORT_REQUEST";
export const GET_TICKET_REPORT_SUCCESS = "GET_TICKET_REPORT_SUCCESS";
export const GET_TICKET_REPORT_FAIL = "GET_TICKET_REPORT_FAIL";
export const GET_TICKET_REPORT_RESET = "GET_TICKET_REPORT_RESET";

// Get TP Batch Report
export const GET_TP_BATCH_REPORT_REQUEST = "GET_TP_BATCH_REPORT_REQUEST";
export const GET_TP_BATCH_REPORT_SUCCESS = "GET_TP_BATCH_REPORT_SUCCESS";
export const GET_TP_BATCH_REPORT_FAIL = "GET_TP_BATCH_REPORT_FAIL";
export const GET_TP_BATCH_REPORT_RESET = "GET_TP_BATCH_REPORT_RESET";

// Get all Currencies
export const GET_CURRENCY_REQUEST = "GET_CURRENCY_REQUEST";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_FAIL = "GET_CURRENCY_FAIL";
export const GET_CURRENCY_RESET = "GET_CURRENCY_RESET";

// Download Excel file
export const DOWNLOAD_EXCEL_REQUEST = "DOWNLOAD_EXCEL_REQUEST";
export const DOWNLOAD_EXCEL_SUCCESS = "DOWNLOAD_EXCEL_SUCCESS";
export const DOWNLOAD_EXCEL_FAIL = "DOWNLOAD_EXCEL_FAIL";
export const DOWNLOAD_EXCEL_RESET = "DOWNLOAD_EXCEL_RESET";

// Download CSV file
export const DOWNLOAD_CSV_REQUEST = "DOWNLOAD_CSV_REQUEST";
export const DOWNLOAD_CSV_SUCCESS = "DOWNLOAD_CSV_SUCCESS";
export const DOWNLOAD_CSV_FAIL = "DOWNLOAD_CSV_FAIL";
export const DOWNLOAD_CSV_RESET = "DOWNLOAD_CSV_RESET";

// Download invoice file
export const DOWNLOAD_INVOICE_REQUEST = "DOWNLOAD_INVOICE_REQUEST";
export const DOWNLOAD_INVOICE_SUCCESS = "DOWNLOAD_INVOICE_SUCCESS";
export const DOWNLOAD_INVOICE_FAIL = "DOWNLOAD_INVOICE_FAIL";
export const DOWNLOAD_INVOICE_RESET = "DOWNLOAD_INVOICE_RESET";

// Email multi PCC ticket report
export const EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST =
  "EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST";
export const EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS =
  "EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS";
export const EMAIL_MULTI_PCC_TICKET_REPORT_FAIL =
  "EMAIL_MULTI_PCC_TICKET_REPORT_FAIL";
export const EMAIL_MULTI_PCC_TICKET_REPORT_RESET =
  "EMAIL_MULTI_PCC_TICKET_REPORT_RESET";

// Get customer logins by id
export const GET_CUSTOMER_LOGINS_BY_ID_REQUEST =
  "GET_CUSTOMER_LOGINS_BY_ID_REQUEST";
export const GET_CUSTOMER_LOGINS_BY_ID_SUCCESS =
  "GET_CUSTOMER_LOGINS_BY_ID_SUCCESS";
export const GET_CUSTOMER_LOGINS_BY_ID_FAIL = "GET_CUSTOMER_LOGINS_BY_ID_FAIL";
export const GET_CUSTOMER_LOGINS_BY_ID_RESET =
  "GET_CUSTOMER_LOGINS_BY_ID_RESET";

// Update customer user default logo
export const UPDATE_CUSTOMER_USER_DEFAULT_LOGO_REQUEST =
  "UPDATE_CUSTOMER_USER_DEFAULT_LOGO_REQUEST";
export const UPDATE_CUSTOMER_USER_DEFAULT_LOGO_SUCCESS =
  "UPDATE_CUSTOMER_USER_DEFAULT_LOGO_SUCCESS";
export const UPDATE_CUSTOMER_USER_DEFAULT_LOGO_FAIL =
  "UPDATE_CUSTOMER_USER_DEFAULT_LOGO_FAIL";
export const UPDATE_CUSTOMER_USER_DEFAULT_LOGO_RESET =
  "UPDATE_CUSTOMER_USER_DEFAULT_LOGO_RESET";

// Get child customer by parent id
export const GET_CHILD_CUSTOMER_BY_PARENT_ID_REQUEST =
  "GET_CHILD_CUSTOMER_BY_PARENT_ID_REQUEST";
export const GET_CHILD_CUSTOMER_BY_PARENT_ID_SUCCESS =
  "GET_CHILD_CUSTOMER_BY_PARENT_ID_SUCCESS";
export const GET_CHILD_CUSTOMER_BY_PARENT_ID_FAIL =
  "GET_CHILD_CUSTOMER_BY_PARENT_ID_FAIL";
export const GET_CHILD_CUSTOMER_BY_PARENT_ID_RESET =
  "GET_CHILD_CUSTOMER_BY_PARENT_ID_RESET";

// Get all Customers
export const GET_ALL_CUSTOMERS_REQUEST = "GET_ALL_CUSTOMERS_REQUEST";
export const GET_ALL_CUSTOMERS_SUCCESS = "GET_ALL_CUSTOMERS_SUCCESS";
export const GET_ALL_CUSTOMERS_FAIL = "GET_ALL_CUSTOMERS_FAIL";
export const GET_ALL_CUSTOMERS_RESET = "GET_ALL_CUSTOMERS_RESET";

// Get customer user logs
export const GET_CUSTOMER_USER_LOGS_REQUEST = "GET_CUSTOMER_USER_LOGS_REQUEST";
export const GET_CUSTOMER_USER_LOGS_SUCCESS = "GET_CUSTOMER_USER_LOGS_SUCCESS";
export const GET_CUSTOMER_USER_LOGS_FAIL = "GET_CUSTOMER_USER_LOGS_FAIL";
export const GET_CUSTOMER_USER_LOGS_RESET = "GET_CUSTOMER_USER_LOGS_RESET";

// Get customer static data
export const GET_CUSTOMER_STATIC_DATA_REQUEST =
  "GET_CUSTOMER_STATIC_DATA_REQUEST";
export const GET_CUSTOMER_STATIC_DATA_SUCCESS =
  "GET_CUSTOMER_STATIC_DATA_SUCCESS";
export const GET_CUSTOMER_STATIC_DATA_FAIL = "GET_CUSTOMER_STATIC_DATA_FAIL";
export const GET_CUSTOMER_STATIC_DATA_RESET = "GET_CUSTOMER_STATIC_DATA_RESET";

// Get customer logo by cust_login_id
export const GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_REQUEST =
  "GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_REQUEST";
export const GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_SUCCESS =
  "GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_SUCCESS";
export const GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_FAIL =
  "GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_FAIL";
export const GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_RESET =
  "GET_CUSTOMER_LOGO_BY_CUST_LOGIN_ID_RESET";

// Delete customer logo
export const DELETE_CUSTOMER_LOGO_REQUEST = "DELETE_CUSTOMER_LOGO_REQUEST";
export const DELETE_CUSTOMER_LOGO_SUCCESS = "DELETE_CUSTOMER_LOGO_SUCCESS";
export const DELETE_CUSTOMER_LOGO_FAIL = "DELETE_CUSTOMER_LOGO_FAIL";
export const DELETE_CUSTOMER_LOGO_RESET = "DELETE_CUSTOMER_LOGO_RESET";

// Update customer default logo
export const UPDATE_CUSTOMER_DEFAULT_LOGO_REQUEST =
  "UPDATE_CUSTOMER_DEFAULT_LOGO_REQUEST";
export const UPDATE_CUSTOMER_DEFAULT_LOGO_SUCCESS =
  "UPDATE_CUSTOMER_DEFAULT_LOGO_SUCCESS";
export const UPDATE_CUSTOMER_DEFAULT_LOGO_FAIL =
  "UPDATE_CUSTOMER_DEFAULT_LOGO_FAIL";
export const UPDATE_CUSTOMER_DEFAULT_LOGO_RESET =
  "UPDATE_CUSTOMER_DEFAULT_LOGO_RESET";
